import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IServerValidationHandler, TValidatorError } from '../../model';

export function severityValidator(args: IServerValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { invalid } = control;
    const { severities, value } = args;

    if (invalid) return null;

    const isInValid = severities.includes(value);

    if (isInValid) {
      const vldResponse: TValidatorError = { severity: value };
      return vldResponse;
    }

    return null;
  };
}
